import { gql } from 'apollo-angular';

export const goalCardItemFragment = gql`
  fragment GoalCardItemFragment on GoalCard {
    id
    title
    descriptionJsonContent
    descriptionPlanJsonContent
    descriptionDoJsonContent
    descriptionCheckJsonContent
    descriptionActJsonContent
    descriptionCheckIndicatorsJsonContent
    archivedAt
    createdAt
    completedAt
    endDate
    startDate
    severity
    goalCardStatus
    featured
    attachmentCount
    subDomain {
      id
      title

      parentDomain {
        id
        title
      }
    }
  }
`;

export const goalCardItemForExportFragment = gql`
  fragment GoalCardItemForExportFragment on GoalCard {
    id
    title
    descriptionJsonContent
    descriptionPlanJsonContent
    descriptionDoJsonContent
    descriptionCheckJsonContent
    descriptionCheckIndicatorsJsonContent
    descriptionActJsonContent
    archivedAt
    createdAt
    completedAt
    endDate
    startDate
    severity
    goalCardStatus
    subDomain {
      id
      title

      parentDomain {
        id
        title
      }
    }

    linkedCards {
      ... on GoalCard {
        id
        title
        endDate
        startDate
      }
      ... on EventCard {
        id
        title
        endDate
        startDate
      }
    }
  }
`;
